export interface Radii {
  /** @return 5px */
  base: string;
  /** @return 8px */
  button: string;
  /** @return 8px */
  card: string;
  /** @return 8px */
  paper: string;
  /** @return 4px */
  textOnly: string;
}

const radii: Radii = {
  base: '5px',
  button: '8px',
  card: '8px',
  paper: '8px',
  textOnly: '4px'
};

export default radii;
